module.exports = __webpack_public_path__ + "img/img_fj_adress_us@3x.b25042bb.png";